$(document).ready(function() {
    const $storesJson = $('.stores-json');
    const $storesWrapper = $('.product-accordion-wrapper');

    function sliseArrays(arr, subarr, maxLength) {
        for (let i = 0; i < Math.ceil(arr.length / maxLength); i++){
            subarr[i] = arr.slice((i * maxLength), (i * maxLength) + maxLength); 
        }
       
    }

    function storesHtml() {
        const json = JSON.parse($storesJson.html());
        const countries = json.countries;
        const stores = json.storesList;
        console.log(json);

        let countriesRowMaxLength;

        let storesGroup = [];

        let htmlButtonsArr = [];
        let htmlButtonsSubArray = [];

        let htmlBodiesArr = [];
        let htmlBodiesSubArray = [];


        //media
        if (window.innerWidth > 1100) {
            countriesRowMaxLength = 4;
        } else if (window.innerWidth > 768) {
            countriesRowMaxLength = 3;
        } else if (window.innerWidth > 575) {
            countriesRowMaxLength = 2;
        } else {
            countriesRowMaxLength = 1;
        }

        //push each country markup to own wrapper
        $.each(countries, (index, country) => {
            const countrySelector = country.selector;
            const title = country.name;
            const image = country.flag;
            let data = {
                country: countrySelector,
                stores: []
            };
            
            const countryButtonHtml =
                '<div class="product-single__accordion" data-country="'+ countrySelector +'">\n' +
                    '<div>\n' +
                        '<div class="product-accordion-title-wrap">\n' +
                            '<img\n' +
                            'src="'+ image +'"\n' +
                            'width="32"\n' +
                            'height="30"\n' +
                            'alt="flag">\n' +
                            '<div class="product-single__accordion-title">'+ title +'<span class="country-count" data-stores-total="" data-country="'+ countrySelector +'"></span>'+'</div>\n' +
                        '</div>\n' +
                        '<i>\n' +
                            '<svg\n' +
                            'width="12"\n' +
                            'height="14"\n' +
                            'viewBox="0 0 12 14"\n' +
                            'fill="none"\n' +
                            'xmlns="http://www.w3.org/2000/svg">\n' +
                                '<path d="M1.44 7.152L5.784 11.328L5.784 0.479999L6.744 0.479999L6.744 11.328L11.112 7.152L11.76 7.848L6.264 13.128L0.768 7.848L1.44 7.152Z" fill="#4B4B4B" />\n' +
                            '</svg>\n' +
                        '</i>\n' +
                    '</div>\n' +
                '</div>\n';


            const htmlBodyTab = `<div
            class="product-single__accordion-text"
            data-country="${countrySelector}"><h2>${countrySelector}</h2></div>`

            htmlBodiesArr.push(htmlBodyTab)

            htmlButtonsArr.push(countryButtonHtml);


            //push each store to own group 
            $.each(stores, (index, store) => {
                const storeSelector = store.selector;
                const storeImage = store.img_path;
                const storeName = store.name;
                const storeUrl = store.link; 
                const formattedUrl = storeUrl.replace('https://', 'www.').replace('http://', 'www.').replace('/', '');

                if (storeSelector === countrySelector) {
                    const storeData = {
                        image: storeImage,
                        name: storeName,
                        url: storeUrl,
                        formattedUrl: formattedUrl
                    }
                    
                    data.stores.push(storeData)
                }    
            })

            storesGroup.push(data)

        });

            console.log(storesGroup);

        //group countires and tabs content
        sliseArrays(htmlButtonsArr, htmlButtonsSubArray, countriesRowMaxLength);
        sliseArrays(htmlBodiesArr, htmlBodiesSubArray, countriesRowMaxLength);

        //display markup wrappers 
        for (let i = 0; i < Math.ceil(htmlButtonsArr.length / countriesRowMaxLength); i++){

            //headers wrapper
            $storesWrapper.append('<div class="product-accordion-wrapper-row"></div>');  
            
        }   

        //bodies wrapper
        $('.product-accordion-wrapper-row').after('<div class="product-accordion-content-row"></div>');
    
        //display markup counties headers 
        $('.product-accordion-wrapper-row').each((index, row) => {
          
            $.each(htmlButtonsSubArray, (arrIndex, arr) => {

                if ( arrIndex === index ) {
                    $(row).html(arr);
                }
                
            })

        }); 

        //display markup countries bodies
        $('.product-accordion-content-row').each((index, row) => {
          
            $.each(htmlBodiesSubArray, (arrIndex, arr) => {

                if ( arrIndex === index ) {
                    $(row).html(arr);
                }
                
            })


        }); 


        //display stores markup 
        $('.product-single__accordion-text').each((index, accordion) => {

            const accordionCountry = $(accordion).attr('data-country');

            $.each(storesGroup, (index, group) => {
                if ( group.country === accordionCountry ) {

                    const storesData = group.stores
            
                    if ( storesData.length > 0 ) {
                        $.each(storesData, (index, store) => {
                        
                            const html = '<div class="product-single__accordion-item">\
                                            <div class="product-single__accordion-item--img">\
                                                 <img src="' + store.image + '"/>\
                                           </div>\
                                            <div class="product-single__accordion-item--title">' +
                                                store.name +
                                            '</div>\
                                            <a href="' + store.url +'" target="_blank" rel="noopener noreferrer">' + store.formattedUrl + '</a>\
                                        </div>';
                               
                            $(accordion).append(html);
                        })
                    } else {
                        $(accordion).append('<div><p>There is no available stores in your country</p></div>')
                    }
                    
                }
            })
              
        });

        $('.country-count').each((index, count) => {
           const countDataCountry = $(count).attr('data-country');
           const accordions = $('.product-single__accordion-text');

           accordions.each((index, accordion) => {
            const accordionBodyDataCountry = $(accordion).attr('data-country');

            if ( countDataCountry === accordionBodyDataCountry ) {
                $(count).text('(' + $(accordion).find('.product-single__accordion-item').length + ')')
            }

           })
           
           
        })

    }

    if ($storesJson.length) {

        storesHtml();
        
        $(document).on('click', '.product-single__accordion', function() {
            const tabsBodies = $('.product-single__accordion-text');

            const activeTab = $('.product-single__accordion.active');

           if ( window.innerWidth > 575 ) {
            activeTab.not(this).removeClass('active');
           }

            $(this).toggleClass('active');

            tabsBodies.each((index, body) => {
                
                if ( $(body).attr('data-country') === $(this).attr('data-country')) {
                   
                    if ( $(this).hasClass('active') ) {
                        $(body).show(400)
                        
                    
                    } else {
                        $(body).hide(400)
                    }

                } else {
                    if ( window.innerWidth > 575 ) {
                        $(body).hide(400)
                    }
                }

            });

        });

    }
// == Show/Hide Menu ==
// First submenu
$('.location-menu__button').on('click', function(event) {
    event.preventDefault();
    $('.location-menu__submenu_1').toggleClass('show');
  });
  
  //   $(document).on('click', function(event) {
  //     if ($(event.target).closest('.location-menu__item').length === 0) {
  //         $('.location-menu__submenu').removeClass('show');
  //     }
  //     console.log($(event.target).closest('.location-menu__submenu').length);
  // });
  
  $(document).on('click', function() {
  if (!$(".location-menu__button:hover").length && !$(".partners__button:hover").length) {
    $(".location-menu__submenu:not(:hover)").removeClass('show');
    $('svg').removeClass('active');
  }
  });
})